export const cancanMixins = {
  // 权限判断
  async can(name) {

    const {permissionMap} = await this.$store.state.user

    return permissionMap[name] || false
  }
}
